import React from 'react';

import { DOCUMENTATION_LINKS } from 'dictionary';
import { UiKit } from 'components';

const { RR_TERMS_OF_USE, RR_PRIVACY_POLICY } = DOCUMENTATION_LINKS;

export default function Checkbox({
  checked = false,
  disabled = false,
  onToggle = () => {},
  className = ''
}) {
  return (
    <UiKit.Checkbox
      checked={checked}
      onChange={onToggle}
      disabled={disabled}
      className={className}
      label={
        <>
          I confirm that I have read and accept the&nbsp;
          <a
            href={RR_TERMS_OF_USE}
            target="_blank"
            rel="noopener noreferrer"
            onClick={e => e.stopPropagation()}
            className="underline"
          >
            Terms of Service
          </a>{' '}
          &nbsp; and &nbsp;
          <a
            href={RR_PRIVACY_POLICY}
            target="_blank"
            rel="noopener noreferrer"
            onClick={e => e.stopPropagation()}
            className="underline"
          >
            Privacy Policy
          </a>
        </>
      }
    />
  );
}
